import { useQuery } from '@apollo/react-hooks';

import { useFitment, useMyStore } from '../hooks';

import { GET_BRAND_DOES_FIT_DATA } from '../../../shared/graphql/check-fit-queries';

import { getVehicleInput } from '../../utils/fitment/fitment';

export default function useDoesBrandFit({
  productType,
  categoryCode,
  skipDoesFitQuery
}) {
  const { selectedFitment } = useFitment();
  const { myStore } = useMyStore();
  const { data, loading: isLoading } = useQuery(GET_BRAND_DOES_FIT_DATA, {
    fetchPolicy: 'cache-and-network',
    skip:
      !productType ||
      !categoryCode ||
      !myStore?.code ||
      !selectedFitment ||
      Boolean(skipDoesFitQuery),
    variables: {
      categoryCode,
      productType,
      storeCode: myStore?.code,
      vehicleInfo: getVehicleInput(selectedFitment)
    }
  });

  return {
    doesFitEnum: data?.checkFit?.brandCategory,
    isLoading
  };
}
